import { createElement, forwardRef } from 'react';
import hoistNonReactStatics from 'hoist-non-react-statics';
import invariant from 'invariant';

import useProducts from 'Hooks/useProducts';

export default function withProducts(Component) {
  const displayName = `withProducts(${ (Component.displayName || Component.name || 'Component') })`;

  const WithProducts = forwardRef((props, ref) => {
    const productsContext = useProducts();
    invariant(
      productsContext,
      `You should not use <${displayName} /> outside a <ProductsProvider />`
    );
    return createElement(Component, {
      productsContext,
      ref,
      ...props
    });
  });

  WithProducts.displayName = displayName;
  WithProducts.WrappedComponent = Component;

  return hoistNonReactStatics(WithProducts, Component);
}
